// src/pages/attendance/config/translations.js

export const translations = {
  ar: {
    pageTitle: "نظام الحضور والانصراف",
    timeTracker: {
      checkIn: "تسجيل الحضور", checkOut: "تسجيل الانصراف",
      alreadyCheckedIn: "تم تسجيل الحضور بالفعل", notCheckedIn: "لم يتم تسجيل الحضور",
      processingCheckIn: "جاري تسجيل الحضور...", processingCheckOut: "جاري تسجيل الانصراف...",
      inZone: "داخل منطقة العمل", outOfZone: "خارج منطقة العمل",
      locationError: "خطأ في تحديد الموقع", tryAgain: "حاول مرة أخرى",
      refreshLocation: " تحديث الموقع", refreshing: " جاري التحديث...",
      distanceToCenter: "المسافة من المركز",
      loadingLocation: "جاري تحميل موقع العمل...", gettingLocation: "جاري تحديد موقعك...",
      withinZone: " داخل المنطقة", outZone: " خارج المنطقة",
    },
    stats: {
      presentDays: "أيام الحضور", absentDays: "أيام الغياب",
      lateArrivals: "مرات التأخير", totalHours: "إجمالي الساعات", thisMonth: "هذا الشهر",
    },
    weekDays: {
      Sunday: "الأحد", Monday: "الاثنين", Tuesday: "الثلاثاء", Wednesday: "الأربعاء",
      Thursday: "الخميس", Friday: "الجمعة", Saturday: "السبت",
    },
    weekly: {
      title: "حضور هذا الأسبوع", weekend: "عطلة", restDay: "يوم راحة",
      in: "دخول:", out: "خروج:", present: "حاضر", absent: "غائب", late: "متأخر",
      summary: "ملخص الأداء الأسبوعي", presentDaysCount: "أيام الحضور",
      lateArrivalsCount: "مرات التأخير", absentDaysCount: "أيام الغياب", totalHoursCount: "إجمالي الساعات",
    },
    performance: {
      title: "مقاييس الأداء", attendanceRate: "معدل الحضور", punctuality: "الالتزام بالمواعيد",
      avgHoursPerDay: "متوسط الساعات/اليوم", overtimeHours: "ساعات إضافية",
      current: "الحالي:", target: "الهدف:",
    },
    monthly: {
      title: "سجل الحضور الشهري", month: "الشهر", presentDays: "أيام الحضور",
      absentDays: "أيام الغياب", lateDays: "أيام التأخير", totalDays: "إجمالي الأيام",
      attendanceRate: "معدل الحضور", performance: "الأداء",
    },
    recent: {
      title: "السجلات الأخيرة", date: "التاريخ", checkIn: "وقت الدخول",
      checkOut: "وقت الخروج", totalHours: "إجمالي الساعات", status: "الحالة", complete: "مكتمل",
    },
    status: { present: "حاضر", absent: "غائب", late: "متأخر", weekend: "عطلة", Complete: "مكتمل", onLeave: "في إجازة", leave: "في إجازة", "On Leave": "في إجازة", rest_day: "يوم راحة", "Rest Day": "يوم راحة", holiday: "إجازة رسمية", half_day: "نصف يوم" },
    units: { hours: "ساعة", meters: "متر" },
    workFromHome: {
      requestButton: "طلب العمل من المنزل", modalTitle: "طلب العمل من المنزل",
      selectDate: "اختر التاريخ", reason: "سبب الطلب",
      reasonPlaceholder: "اكتب سبب طلب العمل من المنزل...",
      submit: "إرسال الطلب", cancel: "إلغاء", submitting: "جاري الإرسال...",
      success: "تم إرسال طلب العمل من المنزل بنجاح", error: "فشل في إرسال الطلب",
      pending: "طلب العمل من المنزل قيد الانتظار", approved: "تمت الموافقة على العمل من المنزل",
      rejected: "تم رفض طلب العمل من المنزل", workingFromHome: "تعمل من المنزل اليوم",
      locationBypassed: "اشتغل من البيت",
    },
    locationIssues: {
      NO_WORK_LOCATION: {
        title: "لم يتم تحديد موقع عمل لك",
        hint: "لا يوجد موقع عمل مسجّل لك اليوم، لذلك لا يمكن تسجيل الحضور. تواصل مع الموارد البشرية أو مديرك المباشر لإضافة موقع العمل، أو قدّم طلب عمل من المنزل.",
      },
      EMPLOYEE_NOT_FOUND: {
        title: "لم يتم العثور على ملفك الوظيفي",
        hint: "حسابك غير مربوط بملف موظف، لذلك لا يمكن تحديد موقع عملك. تواصل مع الموارد البشرية.",
      },
      MISSING_EMPLOYEE_CODE: {
        title: "حسابك غير مربوط بكود موظف",
        hint: "لا يمكن تحميل موقع عملك بدون كود الموظف. تواصل مع الموارد البشرية لربط حسابك.",
      },
      AREA_LOAD_FAILED: {
        title: "تعذّر تحميل موقع العمل",
        hint: "حدثت مشكلة في الاتصال بالخادم. تأكد من اتصالك بالإنترنت ثم حاول مرة أخرى.",
      },
      PERMISSION_DENIED: {
        title: "الوصول إلى موقعك مرفوض",
        hint: "المتصفح غير مسموح له بمعرفة موقعك. فعّل الإذن بالخطوات التالية ثم اضغط «حاول مرة أخرى».",
        steps: ["أيقونة القفل بجوار العنوان", "إعدادات الموقع", "الموقع ← سماح"],
      },
      POSITION_UNAVAILABLE: {
        title: "تعذّر تحديد موقعك",
        hint: "خدمة تحديد الموقع على جهازك مغلقة أو الإشارة غير متاحة.",
        steps: ["إعدادات الجهاز", "الخصوصية ← الموقع", "تشغيل خدمة الموقع"],
      },
      TIMEOUT: {
        title: "استغرق تحديد موقعك وقتًا طويلًا",
        hint: "إشارة الموقع ضعيفة. اقترب من نافذة أو اتصل بشبكة Wi-Fi ثم حاول مرة أخرى.",
      },
      UNSUPPORTED: {
        title: "المتصفح لا يدعم تحديد الموقع",
        hint: "استخدم متصفحًا حديثًا مثل Chrome أو Edge أو Safari لتسجيل الحضور.",
      },
      INSECURE_CONTEXT: {
        title: "تحديد الموقع غير متاح على هذا الرابط",
        hint: "المتصفحات تسمح بتحديد الموقع فقط على اتصال آمن (https). افتح النظام من الرابط الآمن أو تواصل مع الدعم الفني.",
      },
    },
    locationIssueOwners: {
      you: "مطلوب منك", hr: "مطلوب من الموارد البشرية",
      support: "مطلوب من الدعم الفني", connection: "مشكلة اتصال",
    },
  },
  en: {
    pageTitle: "Attendance System",
    timeTracker: {
      checkIn: "Check In", checkOut: "Check Out",
      alreadyCheckedIn: "Already Checked In", notCheckedIn: "Not Checked In",
      processingCheckIn: "Processing Check In...", processingCheckOut: "Processing Check Out...",
      inZone: "Inside Work Zone", outOfZone: "Outside Work Zone",
      locationError: "Location Error", tryAgain: "Try Again",
      refreshLocation: " Refresh Location", refreshing: " Refreshing...",
      distanceToCenter: "Distance from Center",
      loadingLocation: "Loading work location...", gettingLocation: "Getting your location...",
      withinZone: " Within Zone", outZone: " Outside Zone",
    },
    stats: {
      presentDays: "Present Days", absentDays: "Absent Days",
      lateArrivals: "Late Arrivals", totalHours: "Total Hours", thisMonth: "This Month",
    },
    weekDays: {
      Sunday: "Sunday", Monday: "Monday", Tuesday: "Tuesday", Wednesday: "Wednesday",
      Thursday: "Thursday", Friday: "Friday", Saturday: "Saturday",
    },
    weekly: {
      title: "This Week's Attendance", weekend: "Weekend", restDay: "Rest Day",
      in: "In:", out: "Out:", present: "Present", absent: "Absent", late: "Late",
      summary: "Weekly  Summary", presentDaysCount: "Present Days",
      lateArrivalsCount: "Late Arrivals", absentDaysCount: "Absent Days", totalHoursCount: "Total Hours",
    },
    performance: {
      title: "Performance Metrics", attendanceRate: "Attendance Rate", punctuality: "Punctuality",
      avgHoursPerDay: "Avg Hours/Day", overtimeHours: "Overtime Hours",
      current: "Current:", target: "Target:",
    },
    monthly: {
      title: "Monthly Attendance Record", month: "Month", presentDays: "Present Days",
      absentDays: "Absent Days", lateDays: "Late Days", totalDays: "Total Days",
      attendanceRate: "Attendance Rate", performance: "Performance",
    },
    recent: {
      title: "Recent Records", date: "Date", checkIn: "Check In Time",
      checkOut: "Check Out Time", totalHours: "Total Hours", status: "Status", complete: "Complete",
    },
    status: { present: "Present", absent: "Absent", late: "Late", weekend: "Weekend", Complete: "Complete", onLeave: "On Leave", leave: "On Leave", "On Leave": "On Leave", rest_day: "Rest Day", "Rest Day": "Rest Day", holiday: "Holiday", half_day: "Half Day" },
    units: { hours: "hours", meters: "m" },
    workFromHome: {
      requestButton: "Request Work From Home", modalTitle: "Work From Home Request",
      selectDate: "Select Date", reason: "Reason for Request",
      reasonPlaceholder: "Enter reason for working from home...",
      submit: "Submit Request", cancel: "Cancel", submitting: "Submitting...",
      success: "Work from home request submitted successfully", error: "Failed to submit request",
      pending: "Work from home request pending", approved: "Work from home approved",
      rejected: "Work from home request rejected", workingFromHome: "Working from home today",
      locationBypassed: "Location check bypassed",
    },
    locationIssues: {
      NO_WORK_LOCATION: {
        title: "No work location assigned to you",
        hint: "There is no work location set for you today, so check-in isn't possible. Ask HR or your manager to add your work location, or submit a work-from-home request.",
      },
      EMPLOYEE_NOT_FOUND: {
        title: "Employee record not found",
        hint: "Your account isn't linked to an employee record, so your work location can't be loaded. Please contact HR.",
      },
      MISSING_EMPLOYEE_CODE: {
        title: "Your account has no employee code",
        hint: "Your work location can't be loaded without an employee code. Please contact HR to link your account.",
      },
      AREA_LOAD_FAILED: {
        title: "Couldn't load your work location",
        hint: "There was a problem reaching the server. Check your internet connection and try again.",
      },
      PERMISSION_DENIED: {
        title: "Location access is blocked",
        hint: "Your browser isn't allowed to read your location. Allow it with these steps, then press Try again.",
        steps: ["Lock icon by the address bar", "Site settings", "Location → Allow"],
      },
      POSITION_UNAVAILABLE: {
        title: "Your location couldn't be determined",
        hint: "Location services on your device are off or no signal is available.",
        steps: ["Device settings", "Privacy → Location", "Turn location on"],
      },
      TIMEOUT: {
        title: "Finding your location took too long",
        hint: "The location signal is weak. Move closer to a window or connect to Wi-Fi, then try again.",
      },
      UNSUPPORTED: {
        title: "This browser doesn't support location",
        hint: "Use an up-to-date browser such as Chrome, Edge or Safari to check in.",
      },
      INSECURE_CONTEXT: {
        title: "Location isn't available on this link",
        hint: "Browsers only share your location over a secure (https) connection. Open the system from its secure link or contact IT support.",
      },
    },
    locationIssueOwners: {
      you: "Action needed from you", hr: "Handled by HR",
      support: "Handled by IT support", connection: "Connection issue",
    },
  },
};